import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideWanted() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <a id="about-post" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            投稿・応募について
          </Typography>
          　デーリー東北新聞社は、読者から寄せられた文章や写真を幅広く紙面で掲載しています。詳しくは各コーナーをご覧ください。
        </Box>

        <a id="post-kitaouu-haiku" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            北奥羽俳句大会
          </Typography>
          デーリー東北新聞社は11月３日（金・祝）に第71回北奥羽俳句大会を開催します。<br></br>
          事前募集の宿題３題と当日発表の席題２題について１句ずつ詠み、総合点で順位を競います。奮ってご参加ください。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://event-guide.daily-tohoku.news/kitaouu-haiku" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-tanpen" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            第６４回 新春短編小説
          </Typography>
          　デーリー東北新聞社は第64回デーリー東北新春短編小説を募集します。2024年新春の紙面を飾る企画です。選考委員は川上健一氏（作家）、梅内美華子氏（歌人）、米田省三氏（元青森県近代文学館室長）の３人です。奮ってご応募ください。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/tanpen" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-bungei" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー文芸
          </Typography>
          毎月末４日間（12月除く）、文化面に掲載するデーリー文芸（歌壇、俳壇、柳壇、詩壇）の作品を募集しています。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/bungei" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-idle" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            うちのアイドル
          </Typography>
          　成長が楽しみなお子さん、お孫さんの名前や写真を「ひろば面」に掲載するコーナーです。対象は小学校入学前の幼児となります。掲載希望日もご相談ください。掲載の記事付き写真のプリントサービスも有料で受け付けています。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/idol" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-pet" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            マイパートナー
          </Typography>
          　ご家庭で飼っているペット（犬、猫、ウサギ、鳥など）の写真を掲載します。ペットのみが写ったものが対象となります。送っていただいた写真は本社のホームページ（ＨＰ）上でも記事として使用いたします。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/pet" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-kodama" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            こだま
          </Typography>
          　皆さまが日常生活の中で感じた疑問や、現代社会の課題、よりよい地域づくりへの提案などについて、４００字から６００字の文章にまとめ、お寄せください。中学生、高校生を対象にした「若いこだま」もお待ちしています。
          <dl>
            <dt>投稿規定</dt>
            <dd>
              投稿欄「こだま」は本文４００～６００字。郵便番号、住所、氏名（ふりがな）、年齢、生年月日、職業、電話番号をご記入ください。匿名を希望する場合は、その旨も明記してください。「若いこだま」は青森県南、岩手県北地方の中、高校生が対象で、字数や必要事項は「こだま」と同じですが、学校名、学年、保護者の氏名も明記してください。学校単位でも受け付けます。「こだま」「若いこだま」ともに随時受け付けています。文章を添削する場合があります。二重投稿や採否の問い合わせはご遠慮ください。原稿は返却しません。採用された方には薄謝を差し上げます。
            </dd>
            <dt>宛先</dt>
            <dd>
              〒０３１ー８６０１（住所不要）、デーリー東北新聞社報道部「こだま」係＝電話０１７８（８０）７１３８、ファクス０１７８（４５）５９００＝。
            </dd>
          </dl>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/kodama" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-photo" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            フォト
          </Typography>
          　写真投稿のコーナーです。テーマは自由。作品発表の場としてご利用ください。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/photo" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-senior-bunka" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            シニア文化展
          </Typography>
          　６０歳以上の方の芸術作品を紹介するコーナーです。作品発表の場としてご利用ください。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/senior-bunka" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-youngpost" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ヤングポスト
          </Typography>
          　「ヤングポスト」は主に１０、２０代の若者（学生以外も可）向けのページで、応募いただいたイラストや詩などを掲載しています。以下の「詳細」からヤングポストの専用サイトに入ることができますので、投稿フォーム等はそちらでご確認ください。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="http://daily-tohoku.com/youngpost/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-fishing" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            釣果じまん
          </Typography>
          　魚拓や釣り上げた魚の写真を募集しています。写真は、魚を胸元に持ち上げたものや、大漁の釣果が分かる場面を撮影してください。いずれも釣り上げた本人の顔が写っているものに限ります。４～１１月の趣味・レジャー面に掲載しています。皆さんの釣果をどんどん〝自慢〟してください！
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/fishing" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="post-voice" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリーボイス
          </Typography>
          　日々の出来事や、日常生活で感じたことなど、皆さんの「つぶやき」（２００字以内）を紙面に掲載するメッセージコーナーです。（写真添付も可）。投稿内容は編集する場合があります。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://form.daily-tohoku.org/daily-voice" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お申し込みはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/*         
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            第６回 私の天鐘
          </Typography>
          　デーリー東北の一面コラム「天鐘」。<br />
          　時事、季節、歴史、身近な出来事など、書き手の感じたこと、伝えたいことを、決められた文字数の中で分かりやすくまとめています。<br />
          　自由な発想で、あなたの考えをコラムにしてみませんか？<br />
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="http://feature.daily-tohoku.co.jp/mytensho/mytensho.htm" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
        */}

        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北学生文芸大会
          </Typography>
          　デーリー東北新聞社では、「デーリー東北学生文芸大会」を開催します。今年、新型コロナウイルスの影響で文芸活動とその発表の機会を制限されてしまった子どもたちに、文芸に親しんでもらうことを目指します。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/bunka/gakuseibungei" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
        */}

        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            第１１回新聞感想文コンクール
          </Typography>
          　デーリー東北新聞社は、子どもの頃から新聞に親しみ、読解力や表現力を高めることを目的に、第１１回「デーリー東北　新聞感想文コンクール」を実施します。令和２年６月以降のデーリー東北に掲載された記事を読んでの感想を、小学生から高校生までの計４部門で募集します。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/event/newspaperreport" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
        */}
{/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ＧＷの思い出新聞、作ってみよう
          </Typography>
          　“我慢（がまん）ウィーク”を面白（おもしろ）く―。デーリー東北文化部（ＤＴＢ）では、ゴールデンウィーク中の思い出などをまとめた手作り新聞を募集（ぼしゅう）します。面白い作品は後日、紙面で紹介（しょうかい）するかも。説明文や新聞のひな形を参考に作ってみてね。おうちでいろんなことにチャレンジして、新型コロナに負けず楽しいＧＷにしよう！！<br />
          <Paper className="my-3">
          <Grid className="p-3" spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={6}>
              <img src="/images/wanted/hmnp.jpg" className="img-fluid" />
            </Grid>
            <Grid item xs={12} md={6}>
              <ol className="py-3 pr-3 pl-5">
                <li>短歌、俳句（はいく）、川柳（せんりゅう）または一言でもいいので、今の思いをぶちまけよう！</li>
                <Divider className="my-1" />
                <li>自分で新聞タイトルを考えてみよう。</li>
                <Divider className="my-1" />
                <li>名前と住んでいる市町村を書こう。家族みんなの名前を入れてもいいかも。</li>
                <Divider className="my-1" />
                <li>ＧＷ中、おうちでの一番の思い出を、写真を貼はり、４００文字以内で記事にしよう。内容が一目で分かるように、見出しＡ、Ｂを付けてみよう。</li>
                <Divider className="my-1" />
                <li>新型コロナ終息後にやりたいことや夢を書こう。</li>
                <Divider className="my-1" />
                <li>お勧（すす）めの時間のつぶし方を写真付きで紹介（しょうかい）しよう。（例…蘇（そ）作り、宝塚（たからづか）メーク、凝（こ）った料理、運動、自分で考えたゲームなど）</li>
                <Divider className="my-1" />
                <li>自由に使おう。（４）以外の小さなニュース、会えない人へのメッセージ、絵や写真でもＯＫ！</li>
              </ol>
            </Grid>
          </Grid>
          </Paper>
          　応募（おうぼ）は、新聞を切り取って封筒（ふうとう）に入れ、住所、氏名、電話番号を明記して、〒０３１―８６０１、八戸郵便（はちのへゆうびん）局私書箱（ししょばこ）４０号、デーリー東北新聞社文化部「手作り新聞」係へ。または新聞全体を写真に撮影（さつえい）し、画像データをメールアドレス<a href="mailto:bunka@daily-tohoku.co.jp">bunka@daily-tohoku.co.jp</a>までお送りください。対象は青森県南、岩手県北地方の在住・出身者で、年齢（ねんれい）は問いません。５月２０日必着。<br />
          　手作り新聞の用紙は、４月２７日付本紙の９ページを切り取ってご利用いただく、または下記からもダウンロードできます。<br />
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/wanted/hmnp.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  手作り新聞用紙ＤＬ
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
*/}

        {/* <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            投稿・応募
          </Typography>
          　デーリー東北の人気コーナー「うちのアイドル」「マイパートナー」「釣果じまん」「デーリーボイス」の投稿を募集しています。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={3}>
                <CustomButton href="https://form.daily-tohoku.org/idol" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  うちのアイドル
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={3}>
                <CustomButton href="https://form.daily-tohoku.org/pet" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  マイパートナー
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={3}>
                <CustomButton href="http://daily-tohoku.com/youngpost/" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  ヤングポスト
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={3}>
                <CustomButton href="https://form.daily-tohoku.org/fishing" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  釣果じまん
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={3}>
                <CustomButton href="https://form.daily-tohoku.org/daily-voice" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  デーリーボイス
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box> */}

      </div>
    </div>
  );
}

export default GuideWanted;
